import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Wishlist.css";
import Preheader from "../KalHome/Preheader";
import Header from "../KalHome/Header";
import Footer from "../Homecomponents/Footer";
import { cartUtils, wishlistUtils } from "../utils/userCartWishlistUtils";
import axios from "axios";
import SocialLinks from "../Homecomponents/Sociallinks";
import Endfooter from "../Homecomponents/Endfooter";
import Superheader from "../KalHome/Superheader";
import Prefooterads from "../Homecomponents/Prefooterads";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import ProgressLoader from "../Loader/ProgressLoader";

const Wishlist = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [wishlistItems, setWishlistItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [showSizeModal, setShowSizeModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSize, setSelectedSize] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Load wishlist items
  useEffect(() => {
    const loadWishlistItems = async () => {
      try {
        const wishlist = wishlistUtils.getWishlist();
        const productIds = wishlist;

        // Fetch all products
        const productRes = await axios.get(
          "https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_AllProducts_ProductsList"
        );

        const allProducts = productRes.data;

        const items = productIds.map((id) => {
          const product = allProducts.find(
            (p) => p.id.toString() === id.toString()
          );

          return {
            id,
            ...product,
          };
        });

        setWishlistItems(items.reverse());
        setLoading(false);
      } catch (error) {
        console.error("Error loading wishlist items:", error);
        setLoading(false);
      }
    };

    loadWishlistItems();
  }, []);

  const handleRemoveFromWishlist = async (productId) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to remove this product from your wishlist?"
    );

    if (!isConfirmed) return;

    try {
      const success = await wishlistUtils.removeFromWishlist(productId);
      if (success) {
        setWishlistItems((prev) =>
          prev.filter((item) => item.id !== productId)
        );
      }
    } catch (error) {
      console.error("Error removing product from wishlist:", error);
    }
  };

  const handleMoveToCart = (product) => {
    setSelectedProduct(product);
    setSelectedSize("");
    setShowSizeModal(true);
  };

  const handleConfirmMoveToCart = async () => {
    if (!selectedSize) {
      alert("Please select a size first");
      return;
    }

    try {
      const cartSuccess = await cartUtils.addToCart(
        selectedProduct.id, 
        1, 
        selectedSize
      );

      if (cartSuccess) {
        // Then remove from wishlist
        const wishlistSuccess = await wishlistUtils.removeFromWishlist(
          selectedProduct.id
        );
        if (wishlistSuccess) {
          setWishlistItems((prev) =>
            prev.filter((item) => item.id !== selectedProduct.id)
          );
          setShowSizeModal(false);
          setSelectedProduct(null);
          setSelectedSize("");
        }
      } else {
        setShowAlert(true);
        setShowSizeModal(false);
      }
    } catch (error) {
      console.error("Error moving to cart:", error);
    }
  };

  const handleProductClick = (product) => {
    navigate(`/product/${product.id}`, { state: { product } });
  };

  // Parse variants from product
  const getProductVariants = (product) => {
    try {
      return product.variants ? JSON.parse(product.variants) : [];
    } catch (e) {
      console.error("Error parsing variants", e);
      return [];
    }
  };

  if (loading) {
    return (
      <>
        <Superheader />
        <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
          <Header />
        </div>
        <div className="wishlistnew-loading-container">
          <div className="wishlistnew-loading-spinner">Loading your wishlist...</div>
          <ProgressLoader />
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Superheader />
      <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
        <Header />
      </div>
      <div className="wishlistnew-main-container">
        <h2 className="wishlistnew-page-title" style={{ color: "#920504" }}>
          <i className="fa fa-heart me-2"></i> My Wishlist
        </h2>

        {wishlistItems.length === 0 ? (
          <div className="wishlistnew-empty-message">
            <p>Your wishlist is empty. Start adding products you love!</p>
            <button 
              className="wishlistnew-continue-btn" 
              onClick={() => navigate("/")}
            >
              Continue Shopping
            </button>
          </div>
        ) : (
          <div className="wishlistnew-products-grid">
            {wishlistItems.map((item) => (
              <div key={item.id} className="wishlistnew-product-card">
                <div
                  className="wishlistnew-product-image-container"
                  onClick={() => handleProductClick(item)}
                >
                  <img
                    src={
                      item.productImage
                        ? `https://api.dremerz.net/uploads/${item.productImage}`
                        : "/default-product.jpg"
                    }
                    alt={item.productName || "Product"}
                    className="wishlistnew-product-image"
                  />
                  {item.tags && (
                    <span className="wishlistnew-product-tag">{item.tags}</span>
                  )}
                </div>
                <div className="wishlistnew-product-info">
                  <h3 onClick={() => handleProductClick(item)}>
                    {item.brandName || item.productName}
                  </h3>
                  <p className="wishlistnew-product-name m-0">
                    {item.productName}
                  </p>
                  <div
                    className="wishlistnew-product-price"
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <span
                      className="wishlistnew-current-price"
                      style={{ fontSize: "18px" }}
                    >
                      ₹{item.sellingPrice}
                    </span>

                    {item.originalPrice && (
                      <>
                        <span
                          className="wishlistnew-original-price"
                          style={{
                            fontSize: "14px",
                            textDecoration: "line-through",
                          }}
                        >
                          ₹{item.originalPrice}
                        </span>
                        <span
                          className="wishlistnew-offer"
                          style={{
                            fontSize: "14px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          (
                          {Math.round(
                            ((item.originalPrice - item.sellingPrice) /
                              item.originalPrice) *
                              100
                          )}
                          % OFF)
                        </span>
                      </>
                    )}
                  </div>

                  <div className="wishlistnew-product-actions">
                    <button
                      className="wishlistnew-move-to-cart-btn"
                      onClick={() => handleMoveToCart(item)}
                    >
                      Add To Cart
                    </button>
                    <button
                      className="wishlistnew-remove-btn"
                      onClick={() => handleRemoveFromWishlist(item.id)}
                    >
                      <i className="fa fa-trash"></i>
                      
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Size Selection Modal */}
      {showSizeModal && selectedProduct && (
        <div className="wishlistnew-modal-overlay">
          <div className="wishlistnew-modal-content">
            <div className="wishlistnew-modal-header">
              <h5 className="wishlistnew-modal-title">Select Size</h5>
              <button
                type="button"
                className="wishlistnew-modal-close"
                onClick={() => {
                  setShowSizeModal(false);
                  setSelectedProduct(null);
                  setSelectedSize("");
                }}
              >
                &times;
              </button>
            </div>
            <div className="wishlistnew-modal-body">
              <p>Please select a size for <strong>{selectedProduct.productName}</strong></p>
              <div className="wishlistnew-size-options">
                {getProductVariants(selectedProduct).map((variant) => (
                  variant.stockQuantity > 0 && (
                    <button
                      key={variant.variantUnit}
                      className={`wishlistnew-size-btn ${selectedSize === variant.variantUnit ? 'wishlistnew-size-selected' : ''}`}
                      onClick={() => setSelectedSize(variant.variantUnit)}
                    >
                      {variant.variantUnit}
                    </button>
                  )
                ))}
                {getProductVariants(selectedProduct).length === 0 && (
                  <p>No sizes available for this product.</p>
                )}
              </div>
            </div>
            <div className="wishlistnew-modal-footer">
              <button
                type="button"
                className="wishlistnew-modal-cancel"
                onClick={() => {
                  setShowSizeModal(false);
                  setSelectedProduct(null);
                  setSelectedSize("");
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="wishlistnew-modal-confirm"
                onClick={handleConfirmMoveToCart}
                disabled={!selectedSize}
              >
                Add to Cart
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Login Alert Modal */}
      {showAlert && (
        <div className="wishlistnew-alert-overlay">
          <div className="wishlistnew-alert-content">
            <div className="wishlistnew-alert-header">
              <h5 className="wishlistnew-alert-title">Login Required</h5>
              <button
                type="button"
                className="wishlistnew-alert-close"
                onClick={() => setShowAlert(false)}
              >
                &times;
              </button>
            </div>
            <div className="wishlistnew-alert-body">
              <p>Please login to continue.</p>
            </div>
            <div className="wishlistnew-alert-footer">
              <button
                type="button"
                className="wishlistnew-alert-cancel"
                onClick={() => setShowAlert(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="wishlistnew-alert-login"
                onClick={() => navigate("/login")}
              >
                Login
              </button>
            </div>
          </div>
        </div>
      )}
      <Prefooterads />
      <Footer />
      <SocialLinks />
      <Endfooter />
    </>
  );
};

export default Wishlist;